import React from 'react';
import PropTypes from 'prop-types';
import parse, { domToReact } from 'html-react-parser';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useSiteCopySelector from 'components/useSiteCopySelector';

const useStyles = makeStyles(theme => ({
  container: {
    backgroundColor: '#EDF8FF',
    width: '100%',
  },
  wrapper: {
    paddingTop: 81,
    paddingBottom: 81,
    width: '80%',
    margin: 'auto',
    maxWidth: 1080,
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      backgroundColor: '#EDF8FF',
      paddingTop: 80,
      paddingBottom: 110,
      flexDirection: 'column',
    },
  },
  imageWrapper: {
    width: '47.25%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  image: {
    height: 'auto',
    width: '100%',
  },
  contentWrapper: {
    width: '47.25%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  h1: {
    fontFamily: 'PoppinsSemiBold',
    fontSize: 35,
    fontWeight: '600',
    color: '#333333',
    lineHeight: '1.1em',
    paddingBottom: 10,
    marginBottom: '5.82%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  body: {
    fontFamily: 'OpenSansRegular',
    fontWeight: '400',
    fontSize: 20,
    lineHeight: '25px',
    textAlign: 'left',
    color: '#666666',
    marginBottom: '5.82%',
    '&:last-child': {
      marginBottom: 0,
    },
    '& > a': {
      color: '#2EA3F2',
      '-webkit-appearance': 'none',
    },
    '& > b': {
      fontFamily: 'OpenSansBold',
    },
    [theme.breakpoints.down('sm')]: {
      marginBottom: 30,
    },
  },
}));

function SmartScreen({ onPageExit }) {
  const [solutionsSiteCopy] = useSiteCopySelector(['solutions-homepage']);
  const config = _get(solutionsSiteCopy, 'pageCopy.smartscreen', {});
  const classes = useStyles();

  const options = {
    replace: domNode => {
      if (domNode.name === 'a') {
        return (
          <a
            role="link"
            tabIndex={0}
            onClick={() => onPageExit(domNode.attribs.href, 'smartscreen')}
            {...domNode.attribs}
          >
            {domToReact(domNode.children)}
          </a>
        );
      }
      return domToReact(domNode);
    },
  };

  return (
    <section id="smartscreen">
      <div className={classes.container}>
        <div className={classes.wrapper}>
          <div className={classes.imageWrapper}>
            <img
              src={config.image}
              className={classes.image}
              alt="SmartScreen"
            />
          </div>
          <div className={classes.contentWrapper}>
            <Typography className={classes.h1}>
              {parse(config.header, options)}
            </Typography>
            {config.body && (
              <Typography className={classes.body}>
                {parse(config.body, options)}
              </Typography>
            )}
            {parse(config.button, options)}
          </div>
        </div>
      </div>
    </section>
  );
}

SmartScreen.propTypes = {
  onPageExit: PropTypes.func,
};

export default SmartScreen;
